import { Component } from '@theme/component';

/**
 * Mobile bottom tab bar. Opens the existing header cart drawer when cart uses drawer mode.
 *
 * @extends {Component}
 */
class MobileTabBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    const cartButton = this.querySelector('[data-mobile-tab-cart-drawer]');
    cartButton?.addEventListener('click', this.#openCartDrawer);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const cartButton = this.querySelector('[data-mobile-tab-cart-drawer]');
    cartButton?.removeEventListener('click', this.#openCartDrawer);
  }

  #openCartDrawer = (event) => {
    event.preventDefault();

    const drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (drawerTrigger instanceof HTMLElement) {
      drawerTrigger.click();
      return;
    }

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.showDialog === 'function') {
      drawer.showDialog();
      return;
    }

    window.location.href = this.dataset.cartUrl || '/cart';
  };
}

if (!customElements.get('mobile-tab-bar')) {
  customElements.define('mobile-tab-bar', MobileTabBar);
}
